
import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index';
import tpl from './tpl.html';
import util from '../../../lib/util.js';

import './style.scss';

const clickType = util.isPC() ? 'click' : 'tap';

const LOG_C = 'recommend';
let app = null;

export default function recommend(data) {
  app = this;
  const $wrap = $('<div class="m-recommend-wrap"></div>');
  data.suggestRobot = app.util.lang.get('ROBOT:RECOMMEND:RELATED');
  const param = {
    name: 'recommend',
    mid: data.mid,
    type: 'text',
    content: tpl.render(data),
  };
  const $node = $(BaseUI.msg(param));
  // app.postMessage({
  //   type: 'robot',
  //   body: {
  //     text: this.util.lang.get('ROBOT:SUGGEST'),
  //   },
  // }).then((res) => {
  //   $wrap.append(res.body);
  //   $wrap.append($node);
  // });
  $wrap.append($node);

  $node.find('.J_Recommend').on(clickType, (ev) => {
    const $target = $(ev.currentTarget);
    const text = $target.find('a').text();
    const position = $node.find('.J_Recommend').index($target);
    const knowledgeId = $target.attr('data-kid');
    const ontologyId = data.ontologyId;
    const ontologyName = data.ontologyName;
    this.view.footer.submit({
      q: text,
      ext: { ontologyId, ontologyName, knowledgeId, chatUuid: data.chatUuid },
    });
    this.log.send({
      c: LOG_C,
      d: 'knowledge',
      chatUuid: data.chatUuid,
      ext: {
        position,
        knowledgeId,
        title: text,
      },
    });
  });

  return {
    // 插件返回的结果
    body: $wrap,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/recommend/index.js